export const ShowMore = {
	selectors: {
		showMoreSelector: Array.prototype.slice.call(document.querySelectorAll('.js-show-more'))
	},

	init: function() {
		let self = this;

		if (self.selectors.showMoreSelector) {
			self.eventShowMore(self.selectors.showMoreSelector);
		};
	},

	eventShowMore: function(_button) {
		let self = this;

		_button.forEach(function(x) {
			x.addEventListener('click', function(event) {
				event.preventDefault();

				self.rollUpMoreVariants(x);
			});
		});
	},

	rollUpMoreVariants: function(_button) {
		let self = this;
		let button = _button;
		let childrenSelectors = Array.prototype.slice.call(document.querySelectorAll(button.dataset.childrenSelectors));

		childrenSelectors.forEach(function(x) {
			if (x.classList.contains('is-hidden')) {
				x.classList.remove('is-hidden')
			}
		});

		button.parentNode.removeChild(button);

		let moreTipsSelector = document.querySelector('.js-more-tips-text');
		if (moreTipsSelector) {
			if (moreTipsSelector.classList.contains('is-hidden')) {
				moreTipsSelector.classList.remove('is-hidden')
			}
		}

		return false;
	}
}

ShowMore.init();

